import { render, staticRenderFns } from "./QuestionBoardView.vue?vue&type=template&id=75d2de80&scoped=true&"
import script from "./QuestionBoardView.vue?vue&type=script&lang=ts&"
export * from "./QuestionBoardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2de80",
  null
  
)

export default component.exports